export default "/dist/files/ppt.f8f58ff5772c1ab611f5faf307ddbf4e.svg";